export default __webpack_public_path__ + "static/media/Winterrain_primary.c2409872.jpg";